import { PaymentsApi } from '../clients';

export const revokeACHAuthorization = async (bankId) => PaymentsApi.revokeACHAuthorization(bankId);
